<div nz-row>
    <div
        nz-col
        nzSpan="12"
        nzOffset="6"
        [ngClass]="'p-3'"
    >
        <h1 nz-typography>Activează-ți contul Doctor Business</h1>

        <form
            nz-form
            [formGroup]="passwordResetForm"
            class="password-reset-form"
            (ngSubmit)="onSubmit()"
        >
            <nz-form-item>
                <nz-form-label
                    [nzSm]="6"
                    [nzXs]="24"
                    nzRequired
                    nzFor="password"
                >
                    Parola
                </nz-form-label>
                <nz-form-control
                    [nzSm]="14"
                    [nzXs]="24"
                    nzErrorTip="Te rog sa introduci o parola!"
                >
                    <nz-input-group
                        [nzPrefix]="prefixPassword"
                        [nzSuffix]="suffixTemplate1"
                    >
                        <input
                            [type]="passwordVisible1 ? 'text' : 'password'"
                            nz-input
                            formControlName="password"
                        >
                    </nz-input-group>
                    <ng-template #prefixPassword>
                        <i
                            nz-icon
                            nzType="lock"
                            nzTheme="outline"
                        ></i>
                    </ng-template>
                    <ng-template #suffixTemplate1>
                        <i
                            nz-icon
                            [nzType]="passwordVisible1 ? 'eye-invisible' : 'eye'"
                            (click)="passwordVisible1 = !passwordVisible1"
                        ></i>
                    </ng-template>
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label
                    [nzSm]="6"
                    [nzXs]="24"
                    nzRequired
                    nzFor="verifyPassword"
                >
                    Confirma parola
                </nz-form-label>
                <nz-form-control
                    [nzSm]="14"
                    [nzXs]="24"
                    nzErrorTip="Parola din cele 2 căsuțe trebuie sa fie identice!"
                >
                    <nz-input-group
                        [nzPrefix]="prefixPassword"
                        [nzSuffix]="suffixTemplate2"
                    >
                        <input
                            [type]="passwordVisible2 ? 'text' : 'password'"
                            nz-input
                            formControlName="verifyPassword"
                        >
                    </nz-input-group>
                    <ng-template #prefixPassword>
                        <i
                            nz-icon
                            nzType="lock"
                            nzTheme="outline"
                        ></i>
                    </ng-template>
                    <ng-template #suffixTemplate2>
                        <i
                            nz-icon
                            [nzType]="passwordVisible2 ? 'eye-invisible' : 'eye'"
                            (click)="passwordVisible2 = !passwordVisible2"
                        ></i>
                    </ng-template>
                </nz-form-control>
            </nz-form-item>
            <nz-form-item
                nz-row
                class="register-area"
            >
                <nz-form-control
                    [nzSpan]="14"
                    [nzOffset]="6"
                >
                    <button
                        nz-button
                        nzType="primary"
                        [nzLoading]="loadingSubmit"
                    >
                        Setează parola
                    </button>
                </nz-form-control>
            </nz-form-item>
        </form>

    </div>
</div>
